/**
 * User role constants.
 */
export const ROLES = {
    SUPER_ADMIN: 'super_admin',
    ADMIN: 'admin',
    EXECUTIVE: 'executive',
    TASK_FORCE_CHAIR: 'task-force-chair',
    CHAIR: 'chair',
    PILLAR_CHAIR: 'pillar-chair',
    PROJECT_MANAGER: 'project-manager',
    MEMBER: 'member',
    VIEWER: 'viewer',
};

/**
 * Role hierarchy — higher index = higher privilege.
 */
export const ROLE_HIERARCHY = [
    ROLES.VIEWER,
    ROLES.MEMBER,
    ROLES.CHAIR,
    ROLES.PILLAR_CHAIR,
    ROLES.PROJECT_MANAGER,
    ROLES.TASK_FORCE_CHAIR,
    ROLES.EXECUTIVE,
    ROLES.ADMIN,
    ROLES.SUPER_ADMIN,
];

/**
 * Check if a role meets minimum required level.
 * @param {string} userRole - The user's current role
 * @param {string} requiredRole - The minimum required role
 * @returns {boolean}
 */
export const hasMinimumRole = (userRole, requiredRole) => {
    const userLevel = ROLE_HIERARCHY.indexOf(userRole);
    const requiredLevel = ROLE_HIERARCHY.indexOf(requiredRole);
    return userLevel >= requiredLevel;
};
